/**
 * @namespace Utils
 * @aka Planet.Utils
 */
Planet.Utils = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Private Helpers
   * ------------------------------------------------------------------------
   */

  /**
   * --------------------------------------------------------------------------
   * Public Utils Api
   * --------------------------------------------------------------------------
   */

  var Utils = {

    destroySlick: function($element) {
      if (!$element.hasClass('slick-initialized')) {
        return false;
      }

      $element.find('.slick-arrow').remove();
      $element.find('.slick-dots').remove();
      $element.find('.slick-cloned').remove();
      var $slides = $element.find('.slick-slide');
      $slides.unwrap('.slick-track');
      $slides.unwrap('.slick-list');
      $slides
        .removeClass('slick-slide slick-active slick-center slick-visible slick-current selected')
        .removeAttr('aria-hidden')
        .removeAttr('data-slick-index')
        .each(function() {
          $(this).attr('style', $(this).data('originalStyling'));
        });
      $element.removeClass('slick-initialized slick-slider slick-dotted');
    },

    getScriptOnce: function (id, src, callback) {
      var js;
      var fjs = document.getElementsByTagName('script')[0];
      if (document.getElementById(id)) {
        if (typeof callback === 'function') {
          callback();
        }
        return;
      }
      js = document.createElement('script');
      js.id = id;
      js.src = src;
      js.async = true;
      if (typeof callback === 'function') {
        js.onload = callback;
      }
      fjs.parentNode.insertBefore(js, fjs);
    },
  };
  return Utils;

})(window.jQuery);
